import { render, staticRenderFns } from "./VerticalListDisplay.vue?vue&type=template&id=7e05e544&scoped=true"
import script from "./VerticalListDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerticalListDisplay.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VerticalListDisplay.vue?vue&type=style&index=0&id=7e05e544&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e05e544",
  null
  
)

export default component.exports